<div id="surveyContainer" *ngIf="!isSubmitted"></div>
<!-- Response has been Submitted -->
<div class="cs-response" *ngIf="isSubmitted"  >
    <span class="text-32 font-bold">{{translate.setup.integrations.messages.invalidLink}}</span>
    <span class="text-20 font-medium sub-response">{{translate.setup.integrations.messages.responseSubmit}}</span>
</div>  